module.exports = __webpack_public_path__ + "94733f7eb17b14f2da76b2536ab8c2a2.pdf";